// App.js

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CookieConsentBanner from './components/CookieConsentBanner';
import loadGoogleAnalytics from './utils/gtag';
import { setCookie, getCookie } from './utils/cookies';
import ScrollToTop from './components/ScrollToTop';
import Layout from './layouts/Layout';
import Home from './pages/Home';
import CaseStudies from './pages/CaseStudies/CaseStudies';
import Portfolio from './pages/Portfolio';
// import Contact from './pages/Contact';
import Imprint from './pages/Imprint';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NotFound from './pages/NotFound';

import WebDev from './services/WebDev';
import AppDev from './services/AppDev';
import UIUX from './services/UIUX';
import RequestForm from './pages/RequestForm';
import AGB from './pages/AGB';
import AboutUsSection from './pages/AboutUs';
import Career from './pages/Career';
import BlogPage from './pages/Blogposts/BlogPage';
import OnePagerRequestPage from './pages/ServiceRequest/OnePageRequest';
import LandingPageRequest from './pages/ServiceRequest/LandingPageRequest';

import BlogPostPage from './pages/Blogposts/BlogPostPage';

import CaseStudyPostPage from './pages/CaseStudies/CaseStudyPostPage';

const GA_TRACKING_ID = 'G-94NRJ1R0FQ';

function App() {
  const [cookiePreferences, setCookiePreferences] = useState(null);

  useEffect(() => {
    const savedPrefs = getCookie('cookieConsent');
    if (savedPrefs) {
      try {
        const prefs = JSON.parse(savedPrefs);
        setCookiePreferences(prefs);
        if (prefs.statistics || prefs.marketing) {
          loadGoogleAnalytics(GA_TRACKING_ID);
        }
      } catch (error) {
        console.error("Error parsing cookieConsent", error);
      }
    }
  }, []);

  const handleChooseOption = (option) => {
    let preferences = { essential: true, statistics: false, marketing: false };
    if (option === 'statistik') {
      preferences.statistics = true;
    } else if (option === 'marketing') {
      preferences.marketing = true;
    }
    setCookiePreferences(preferences);
    setCookie('cookieConsent', JSON.stringify(preferences), 365);
    if (preferences.statistics || preferences.marketing) {
      loadGoogleAnalytics(GA_TRACKING_ID);
    }
  };

  return (
    <Router>
      <ScrollToTop />

      {cookiePreferences === null && (
        <CookieConsentBanner onChooseOption={handleChooseOption} />
      )}

      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="kontakt" element={<RequestForm />} />
          <Route path="contact" element={<RequestForm />} />
          <Route path="impressum" element={<Imprint />} />
          <Route path="datenschutz" element={<PrivacyPolicy />} />
          <Route path="projektanfrage" element={<RequestForm />} />
          <Route path="ueber-uns" element={<AboutUsSection />} />
          <Route path="agb" element={<AGB />} />
          <Route path="karriere" element={<Career />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="*" element={<NotFound />} />

          <Route path="/projektanfrage/one-pager" element={<OnePagerRequestPage />} />
          <Route path="/projektanfrage/landing-page" element={<LandingPageRequest />} />

          {/* Directly defined service routes */}
          <Route path="services/web-development" element={<WebDev />} />
          <Route path="services/app-development" element={<AppDev />} />
          <Route path="services/ui-ux-design" element={<UIUX />} />

          {/* Blog posts: dynamic route, content lives in src/content/blog */}
          <Route path="blogpost/:slug" element={<BlogPostPage />} />

          {/* Case studies: dynamic route, content lives in src/content/case-studies */}
          <Route path="case-studies">
            <Route index element={<CaseStudies />} />
            <Route path=":slug" element={<CaseStudyPostPage />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
